var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "depot_documents"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-15"
  }, [_vm.allowed ? _c('div', {
    staticClass: "relative align-middle min-w-full shadow rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('h3', {
    staticClass: "my-5 lg:my-15 2xl:my-20 w-full px-12"
  }, [_vm._v("\n        Dépôt de documents\n      ")]), _vm._v(" "), _vm.path.length > 0 || _vm.folders.length > 0 || _vm.files.length > 0 ? _c('files-list', {
    attrs: {
      "folders": _vm.folders,
      "files": _vm.files,
      "color-by-type": _vm.colorByType,
      "path": _vm.path
    },
    on: {
      "openFolder": function (folder) {
        _vm.addFolderToPath(folder);
      },
      "displayAllFiles": function ($event) {
        return _vm.displayAllFiles();
      },
      "goto": function (index) {
        _vm.goToPath(index);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.path.length == 0 && _vm.folders.length == 0 && _vm.files.length == 0 ? _c('no-file-found') : _vm._e()], 1) : _c('page-not-allowed')], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        Dépôt de documents\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
  }, [_vm._v("\n        Vous pouvez déposer les documents.\n      ")])]);

}]

export { render, staticRenderFns }